const images = {
    // {signa}
    signa2821: require("../Images/SIGNA-2821T.jpg"),
    signa2823: require("../Images/SIGNA-2823T.jpg"),
    signa3125: require("../Images/SIGNA-3125T.jpg"),
    signa3525: require("../Images/SIGNA-3525T.jpg"),
    signa4225: require("../Images/SIGNA-4225T.jpg"),
    signa5530: require("../Images/signa5530s.jpg"),
    signa3530tk: require("../Images/Signa-3530TK.webp"),
    signa4830t: require("../Images/SIGNA-4830T.jpg"),
    signa4830tk: require("../Images/SIGNA-4830TK.jpg"),
    signa2830tk: require("../Images/signa-2830tk.webp"),
    signa2830k: require("../Images/signa-2830k.webp"),
    // {lcv}
    ultrat6: require("../Images/ultra-t6.png"),
    lpt709: require("../Images/LPT-709-G.jpg"),
    lpt710: require("../Images/LPT-710.jpg"),
    lpt712: require("../Images/LPT-712.jpg"),
    ultrat7: require("../Images/Ultra T.7.png"),
    ultrat19: require("../Images/ULTRA-T19.jpg"),
    goldsfc:  require("../Images/LCV-407-gold-sfc.webp"),
    // {MCV}
    lpt1216: require("../Images/LPT-1216.jpg"),
    lpt1212: require("../Images/LPT-1212.jpg"),
    lpt1616: require("../Images/lpt1616.jpg"),
    lpt1816: require("../Images/LPT-1816.jpg"),
    lpt1916: require("../Images/1916-lpt.png"),
    ultrat18: require("../Images/ULTRA-T18.jpg"),
    lpt1112: require("../Images/LPT-1112.jpg"),
    lpt4830: require("../Images/LPT-4830.webp"),
    lpt1912: require("../Images/LPT-1912g.webp"),
    lpt1921: require("../Images/LPT-1921.webp"),
    // {Tippers}
    signa4830: require("../Images/SIGNA-4830T.jpg"),
    signa1923: require("../Images/SIGNA-1923K.jpg"),
    prima2830h:require("../Images/Prima 2830.K Scoop HRT New Fascia_Mer.png"),
    prima3530h:require("../Images/prima 3530 hrt.jpg"),
    prima3530s:require("../Images/3530-k-srt_1.jpg"),
    prima5530s:require("../Images/PRIMA-5530.jpg"),
  

    buslp412:require("../Images/Bus-LP412.jpg"),
    buslp712:require("../Images/LPT-712.jpg"),
    buslp812:require("../Images/LPT-712.jpg"),
    busprime32:require("../Images/Starbus-prime-32.jpg"),
    buslp41236:require("../Images/Bus-LP41236.webp"),
  };
  
  export default images;